
import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PickupService } from 'src/app/services/pickup.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { MatDialog } from '@angular/material/dialog';
// @ts-ignore
import Quagga from "quagga"
import { BarcodeComponent } from 'src/app/modal/barcode/barcode.component';
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment.production";
import { catchError, retry, timeout } from "rxjs/operators";
import { ConfirmacionsimpleComponent } from 'src/app/modal/confirmacionsimple/confirmacionsimple.component';


@Component({
  selector: 'app-bineo',
  templateUrl: './bineo.component.html',
  styleUrls: ['./bineo.component.scss']
})
export class BineoComponent {

  @ViewChild('video') videoElement: ElementRef | undefined;
  code: string='';

  ubicacion:any='';
  ubicacion2:any='';

  ubicaciones:string[]=[];
  ubicaciones2:string[]=[];
  loading:boolean=false;


  bultos:any[]=[];
  selectedItems: boolean[] = [];
  

  constructor(private router: Router,public pickupService : PickupService,public dialog: MatDialog, private utitlityService : UtilitiesService,public http: HttpClient){

    this.ubicaciones.push('RACK');
    this.ubicaciones.push('PALL');
    this.ubicaciones.push('BPAR');


    this.ubicaciones2=['100','200','300','400','500','600','700','800','900'];

    let bultos_bineo = localStorage.getItem('bultos_bineo');
    
    if(bultos_bineo){
      this.bultos = JSON.parse(bultos_bineo);
    }
    
   // this.bultos = [{codigo:"1212121212121",ubicacion:"RACK-700"}];

  }

  ngAfterViewInit() {
 //   this.initCamera();
  }

  eliminarSeleccionados() {
    this.bultos = this.bultos.filter((item, index) => !this.selectedItems[index]);
  }

  iniciarLector(){


      const modal = this.dialog.open(BarcodeComponent, {});

      modal.afterClosed().subscribe((result:string) => {
        console.log('The dialog was closed', result);
        if(result.length>5){

          var ocurrencias= this.bultos.filter(item => item.codigo == result).length;

          if(ocurrencias==0){
            this.bultos.push({codigo:result, ubicacion:this.ubicacion+'-'+this.ubicacion2});
            localStorage.setItem('bultos_bineo',JSON.stringify(this.bultos));
          }else{

            const modal = this.dialog.open(ConfirmacionsimpleComponent,{ data : { titulo : 'Atención', 'mensaje':'BULTO YA BINEADO. NO ESTÁ PERMITIDO INGRESAR NUEVA UBICACIÓN'}});
              modal.afterClosed().subscribe((result:string) => {
                console.log('The dialog was closed', result);
            
              });


          }
        }
     
      });
    
  }


  guardarBultos(){
    this.loading=true;
    console.log('guardar bultos');
    const headers = { 'Content-Type':'application/json','Access-Control-Allow-Origin':'*','Access-Control-Allow-Headers':'*' };

    let payload = {
      bultos:this.bultos,
      local:this.pickupService.usuario.codigo_local,
    };

    console.log(payload);
    
    this.http.post(`${environment.api_host}/api-app/bineo_bultos`,payload,{headers}).pipe(retry(3),timeout(15000), catchError(async e => {
      this.loading=false;
      const modal = this.dialog.open(ConfirmacionsimpleComponent,{ data : { titulo : 'Error', 'mensaje':'Ocurrió un error al enviar los bultos al servidor'}});
      modal.afterClosed().subscribe((result:string) => {
        console.log('The dialog was closed', result);
     
      });
      throw Error('TimeOut');


    })).subscribe((result:any)=>{
      this.loading=false;
      if(result==true){
       
        localStorage.removeItem('bultos_bineo');
        this.bultos=[];

        const modal = this.dialog.open(ConfirmacionsimpleComponent,{ data : { titulo : 'exito', 'mensaje':'Los bultos se han enviado exitosamente'}});
        modal.afterClosed().subscribe((result:string) => {
          console.log('The dialog was closed', result);
       
        });
      }
    });

  }

  deleteElement(index: number): void {
    this.bultos.splice(index, 1);
  }




}
